import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Scrolls document to top on a change of page
 * @param {{ history: any}} params
 * @returns null
 */
function ScrollToTop({ history }) {
  // Scrolls to top when page changes
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return null;
}

export default (withRouter(ScrollToTop));